// src/components/ErrorBoundary.js
// 앱 전체를 감싸는 에러 바운더리 — 예상치 못한 크래시로부터 보호
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // 에러 로깅은 프로덕션에서는 외부 서비스로 전송 가능
    // 콘솔에 민감 정보 노출 방지를 위해 세부 사항 생략
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="bg-card rounded-lg border border-border p-8 max-w-md text-center">
            <h2 className="text-xl font-bold text-foreground mb-3">
              오류가 발생했습니다
            </h2>
            <p className="text-muted-foreground mb-6">
              예상치 못한 오류가 발생했습니다. 페이지를 새로고침해주세요.
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
            >
              새로고침
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
